var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49.69 43.68",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 578",
    d: "M20.69,25.78h8.73v2.91H20.69Z",
    transform: "translate(-0.21 -2.49)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 579",
    d: "M40.53,28.69H32.35v1.46a1.46,1.46,0,0,1-1.46,1.45H19.23a1.45,1.45,0,0,1-1.45-1.45h0V28.69H9.6a4.36,4.36,0,0,1-4.15-3L.21,10V41.8a4.37,4.37,0,0,0,4.37,4.37h41A4.37,4.37,0,0,0,49.9,41.8V10L44.67,25.71A4.37,4.37,0,0,1,40.53,28.69Z",
    transform: "translate(-0.21 -2.49)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 580",
    d: "M30.88,2.49H19.23a4.36,4.36,0,0,0-4.36,4.37V8.31H2.72L8.21,24.78a1.46,1.46,0,0,0,1.38,1h8.19V24.31a1.45,1.45,0,0,1,1.45-1.45H30.88a1.45,1.45,0,0,1,1.46,1.45v1.46h8.18a1.46,1.46,0,0,0,1.39-1L47.4,8.3H35.25V6.85A4.37,4.37,0,0,0,30.88,2.49ZM17.78,8.31V6.86A1.45,1.45,0,0,1,19.23,5.4H30.88a1.46,1.46,0,0,1,1.46,1.46V8.31Z",
    transform: "translate(-0.21 -2.49)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndustry);
export default __webpack_public_path__ + "static/media/icon-industry.be4feef3e572b3ea80a16210a9951f8d.svg";
export { ForwardRef as ReactComponent };